<template>
  <div class="receipt-info-detail">
    <el-tabs class="tab-content" v-model="activeTab" @tab-click="tabClick">
      <el-tab-pane label="回款详情" name="receipt" lazy>
        <info-detail type="receipt" :id="dataId" ref="recepitRef" />
      </el-tab-pane>
      <el-tab-pane label="合同详情" name="contract" lazy>
        <info-detail type="contract" :id="contractId" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import InfoDetail from "./info-detail.vue";
export default {
  name: "receipt-info-detail",
  props: {},
  data() {
    return {
      activeTab: "receipt",
      dataId: this.$route.query.dataId,
      contractId: "",
    };
  },
  methods: {
    tabClick(arg) {
      if (arg.name === "contract") {
        this.contractId = this.$refs.recepitRef.info.contractId;
      }
    },
  },
  components: { InfoDetail },
};
</script>
<style scoped lang="scss">
::v-deep {
  .tab-content.el-tabs {
    .el-tabs__content,.el-tab-pane {
      position: relative;
      top: auto;
      left: auto;
      right: auto;
      bottom: auto;
    }
  }
}
</style>
